(function () {
  var DRAG_THRESHOLD = 6;

  function canScroll(scroller) {
    return scroller.scrollWidth > scroller.clientWidth + 1;
  }

  function bind(scroller) {
    if (scroller.dataset.dragReady === 'true') return;
    scroller.dataset.dragReady = 'true';

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;

    function refresh() {
      scroller.classList.toggle('is-draggable', canScroll(scroller));
    }

    scroller.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (!canScroll(scroller)) return;

      dragging = true;
      moved = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = scroller.scrollLeft;
    });

    scroller.addEventListener('pointermove', function (event) {
      if (!dragging || event.pointerId !== pointerId) return;

      var delta = event.clientX - startX;
      if (!moved && Math.abs(delta) < DRAG_THRESHOLD) return;

      if (!moved) {
        moved = true;
        scroller.classList.add('is-dragging');
        if (!scroller.hasPointerCapture(event.pointerId)) {
          scroller.setPointerCapture(event.pointerId);
        }
      }

      scroller.scrollLeft = startScroll - delta;
    });

    function stop(event) {
      if (!dragging || event.pointerId !== pointerId) return;
      dragging = false;
      pointerId = null;
      scroller.classList.remove('is-dragging');
    }

    scroller.addEventListener('pointerup', stop);
    scroller.addEventListener('pointercancel', stop);

    scroller.addEventListener('click', function (event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);

    window.addEventListener('resize', refresh);
    refresh();
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-subcollection-drag]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
